'use strict'

module.exports = {
    ENTER: 13,
    SPACE: 32,
    END: 35,
    HOME: 36,
    LEFT_ARROW: 37,
    UP_ARROW: 38,
    RIGHT_ARROW: 39,
    DOWN_ARROW: 40,
    ESC: 27,

    _isKey: function(keyCode, value) {
        return keyCode === value;
    },

    _isOneOfKey: function(keyCode, valueArr) {
        let found = false;

        for(let i=0; i<valueArr.length; i++) {
            if(found) {
                continue;
            }

            if(valueArr[i] === keyCode) {
                found = true;
            }
        }

        return found;
    },

    isSelectKey: function(keyCode) {
        return this._isOneOfKey(keyCode, [this.ENTER, this.SPACE]);
    },

    isEnterKey: function(keyCode) {
        return this._isKey(keyCode, this.ENTER);
    },

    isEscKey: function(keyCode) {
        return this._isKey(keyCode, this.ESC);
    },

    isRightArrow: function(keyCode) {
        return this._isKey(keyCode, this.RIGHT_ARROW);
    },

    isLeftArrow: function(keyCode) {
        return this._isKey(keyCode, this.LEFT_ARROW);
    },
    
    
    handleRadioKeyDown: function(radio_ids,e) {
        let myId = e.target.id;
        let myIndex = radio_ids.indexOf(myId);
        if (myIndex < 0) {
            return; // error
        }
        let selIndex = -1;
        switch(e.keyCode) {
            case this.ENTER:
            case this.SPACE:
                selIndex = myIndex;
                break;
            case this.END: // End
                selIndex = radio_ids.length - 1;
                break;
            case this.HOME: // Home
                selIndex = 0;
                break;
                
            case this.LEFT_ARROW:
            case this.UP_ARROW:
                selIndex = (myIndex+radio_ids.length -1) % radio_ids.length; // next in group
                break;

            case this.RIGHT_ARROW:
            case this.DOWN_ARROW:
                selIndex = (myIndex+1) % radio_ids.length; // previous in group
                break;
        }
        if (selIndex >= 0) {
            $(`#${radio_ids[selIndex]}`).focus().click();
            return true;
        }
    }
    
    
    
}

